import { render, staticRenderFns } from "./PsCalendar.vue?vue&type=template&id=97ee1b3e&scoped=true&"
import script from "./PsCalendar.vue?vue&type=script&lang=js&"
export * from "./PsCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ee1b3e",
  null
  
)

export default component.exports